"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var collapsable_component_1 = require("./collapsable.component");
exports.NguiCollapsableComponent = collapsable_component_1.NguiCollapsableComponent;
var collapsable_module_1 = require("./collapsable.module");
exports.NguiCollapsableModule = collapsable_module_1.NguiCollapsableModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/collapsable/dist/index.js
// module id = 533
// module chunks = 4